module.exports = __webpack_public_path__ + "img/home.4c944eba.png";